import React from "react";
import "./ModalCongrats.css";
import { ModalContext } from "./ModalInput";
import { useContext } from "react";
import { auto } from "async";
export function ModalCongrats() {
  var { congrats, Show } = useContext(ModalContext);
  var {modal, setModal} = useContext(ModalContext)
  const Close = () => {
    Show(!congrats);
    setModal(!modal)
  };
  return (
    <div className="modal2">
      <div className="overlay2"></div>
      <div className="modal-content2">
        <img src="icon-check (1).svg" alt="checkmark" className="checkmark" />
        <div className="thanks_title">Thanks for your support!</div>
        <div className="thanks_desc">
          Your pledge brings us one step closer to sharing Mastercraft Bamboo
          Monitor Riser worldwide. You will get an email once{" "}
          <div className='bottom_desc'> our campaign is completed.</div>
        </div>
        <button onClick={() => Close()} className='got_it_button'>Got it!</button>
      </div>
    </div>
  );
}
